<wbo-search-page>
    <wbo-search-form>
        <wbo-search-form-fields>
            <wbo-search-form-field field="orderNo">
                <wbo-simple-search-control></wbo-simple-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field field="supplier">
                <wbo-supplier-multi-select-search-control></wbo-supplier-multi-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-fields>
        <wbo-search-form-extended-fields>
            <wbo-search-form-field *extendedField="'dateFrom'">
               <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
            <wbo-search-form-field *extendedField="'dateTo'">
                <wbo-date-search-control></wbo-date-search-control>
            </wbo-search-form-field>
          <!--  <wbo-search-form-field *extendedField="'outlet'">
               <wbo-outlet-search-control></wbo-outlet-search-control>
            </wbo-search-form-field>-->
            <wbo-search-form-field *extendedField="'status'">
                <wbo-single-select-search-control>
                    <wbo-select-options>
                        <wbo-select-option value="Pending"
                                           label="wbo.purchase-order.option.status.pending"></wbo-select-option>
                        <wbo-select-option value="Receivable"
                                           label="wbo.purchase-order.option.status.receivable"></wbo-select-option>
                        <wbo-select-option value="Received"
                                           label="wbo.purchase-order.option.status.received"></wbo-select-option>
                    </wbo-select-options>
                </wbo-single-select-search-control>
            </wbo-search-form-field>
        </wbo-search-form-extended-fields>
    </wbo-search-form>
    <wbo-search-grid>
        <wbo-column field="orderNo"></wbo-column>
        <wbo-date-column field="created"></wbo-date-column>
        <wbo-column field="supplier"></wbo-column>
        <wbo-column field="status"></wbo-column>
        <wbo-date-column field="emailSent"></wbo-date-column>
        <wbo-column field="employee"></wbo-column>
        <wbo-date-column field="dueDate"></wbo-date-column>
        <wbo-actions-search-column>
            <wbo-report-search-action [idColumn]="'orderId'"></wbo-report-search-action>
            <wbo-delete-search-action></wbo-delete-search-action>
        </wbo-actions-search-column>
    </wbo-search-grid>
</wbo-search-page>
